import { render } from "./PurchaseListComponent.vue?vue&type=template&id=6c148d4a&scoped=true"
import script from "./PurchaseListComponent.vue?vue&type=script&lang=js"
export * from "./PurchaseListComponent.vue?vue&type=script&lang=js"

import "./PurchaseListComponent.vue?vue&type=style&index=0&id=6c148d4a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c148d4a"],['__file',"resources/js/components/admin/purchase/PurchaseListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c148d4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c148d4a', __exports__)) {
    api.reload('6c148d4a', __exports__)
  }
  
  module.hot.accept("./PurchaseListComponent.vue?vue&type=template&id=6c148d4a&scoped=true", () => {
    api.rerender('6c148d4a', render)
  })

}


export default __exports__